var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portico60-croquis"},[_c('h2',[_vm._v("Diagram:")]),_c('img',{attrs:{"src":require('@/assets/images/gamas/60/portico1.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }